import utils from '@/mixins/utils.js'
import { filtrarComorbidades } from './functions.js'
export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Condições de saúde': {
    field: 'comorbidades',
    callback: (value) => {
      return value !== ''
        ? filtrarComorbidades(value)
            .map((c) => c.label)
            .join(', ')
        : ''
    },
  },
  'Médico(A)': {
    field: 'dt_atendimento_medico',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Enfermeiro(A)': {
    field: 'dt_atendimento_enfermeiro',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Odontólogo(A)': {
    field: 'dt_atendimento_odonto',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  ACS: {
    field: 'dt_visita',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
}
